import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function analysisResultList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/analysis/result/list${queryString}`,
  );
}

export async function analysisResultGet(account_id: string, result_id: string) {
  return await clientAxios.get(
    `account/${account_id}/analysis/result/${result_id}/show`,
  );
}

export async function analysisResultCreate(account_id: string, payload: any) {
  return await clientAxios.post(
    `account/${account_id}/analysis/result/create`,
    payload,
  );
}

export async function analysisResultPatch(
  account_id: string,
  result_id: string,
  payload: any,
) {
  return await clientAxios.patch(
    `account/${account_id}/analysis/result/${result_id}/patch`,
    {
      payload,
    },
  );
}

export async function analysisResultDelete(
  account_id: string,
  result_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/analysis/result/${result_id}/delete`,
  );
}

export async function analysisResultResume(
  account_id: string,
  result_id: string,
) {
  return await clientAxios.post(
    `account/${account_id}/analysis/result/${result_id}/resume`,
    {},
  );
}
